import React from 'react';
import { Outlet, useOutlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LoadingScreen } from '@ibinder/common-frontend';

// Utils
import { AuthConsumer } from 'Shared/Auth/AuthProvider';

const PrivateRoute = () => {
  const { t } = useTranslation();
  const outlet = useOutlet();

  return (
    <AuthConsumer>
      {({ isAuthenticated, signinRedirect }) => {
        if (isAuthenticated() && !!outlet) {
          return outlet;
        } else {
          signinRedirect();

          return (
            <LoadingScreen
              statusMessage={t('common:loading')}
              loadingText={t('common:pleaseWait')}
            />
          );
        }
      }}
    </AuthConsumer>
  );
};

export default PrivateRoute;
